import React from 'react';

const LogTable = ({ columns, data, loading, pagination, sorting, darkMode, rowClassName }) => {
  const handleSort = (column) => {
    if (!sorting || !column.sortable) return;
    const newOrder = sorting.sortBy === column.key && sorting.sortOrder === 'asc' ? 'desc' : 'asc';
    sorting.onSort(column.key, newOrder);
  };

  const getSortIcon = (column) => {
    if (!sorting || sorting.sortBy !== column.key) return '↕️';
    return sorting.sortOrder === 'asc' ? '↑' : '↓';
  };

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  if (!data || data.length === 0) {
    return <div className="empty-state">No data available</div>;
  }

  return (
    <div className={`log-table-container ${darkMode ? 'dark-mode' : ''}`}>
      <table className="log-table">
        <thead>
          <tr>
            {columns.map(column => (
              <th
                key={column.key}
                onClick={() => handleSort(column)}
                className={column.sortable ? 'sortable' : ''}
              >
                {column.label}
                {column.sortable && <span className="sort-icon">{getSortIcon(column)}</span>}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => (
            <tr key={row.id || index} className={rowClassName ? rowClassName(row) : ''}>
              {columns.map(column => {
                const cellValue = row[column.key];
                // Check if it's a React element (has $$typeof property)
                if (React.isValidElement(cellValue)) {
                  return <td key={column.key}>{cellValue}</td>;
                }
                // Check if it's a plain object (not null, not array, not Date)
                if (typeof cellValue === 'object' && cellValue !== null && !Array.isArray(cellValue) && !(cellValue instanceof Date)) {
                  try {
                    return <td key={column.key}>{JSON.stringify(cellValue)}</td>;
                  } catch (e) {
                    // If JSON.stringify fails (circular reference), just show a placeholder
                    return <td key={column.key}>[Complex Object]</td>;
                  }
                }
                // For primitives, arrays, dates, etc., render directly
                return <td key={column.key}>{cellValue != null ? String(cellValue) : 'N/A'}</td>;
              })}
            </tr>
          ))}
        </tbody>
      </table>
      {pagination && (
        <div className="pagination">
          <button
            disabled={pagination.currentPage === 1}
            onClick={() => pagination.onPageChange(pagination.currentPage - 1)}
          >
            Previous
          </button>
          <span>
            Page {pagination.currentPage} of {Math.ceil(pagination.totalCount / pagination.pageSize)}
          </span>
          <button
            disabled={pagination.currentPage >= Math.ceil(pagination.totalCount / pagination.pageSize)}
            onClick={() => pagination.onPageChange(pagination.currentPage + 1)}
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
};

export default LogTable;

